import { render, staticRenderFns } from "./addBanners.vue?vue&type=template&id=fa826f7c&"
import script from "./addBanners.vue?vue&type=script&lang=js&"
export * from "./addBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports